// import React from "react";
// import kaskazini2 from "../Assets/Images/kaskazini2.jpeg";
// import kaskazini from "../Assets/Images/kaskaz.jpg";
// import Objectives from "../components/Objectives";
// import Navbar from "../components/Navbar";

// function Campaign() {
//   return (
//     <>
//       <Navbar />
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           minHeight: "100vh",
//         }}
//       >
//         <div
//           className="card bg-base-100 shadow-xl"
//           style={{ marginBottom: "50px", width: "100%" }}
//         >
//           <h1 className="mt-10 mb-20 text-5xl font-bold text-red-500">
//             Kaskazini Centre
//           </h1>
//           <figure style={{ margin: 0 }}>
//             <img
//               src={kaskazini}
//               alt="Movie"
//               style={{ width: "100%", marginLeft: "20px" }}
//             />
//           </figure>
//           <div className="card-body">
//             <p className="text-white text-left w-1/2 mx-auto mb-20">
//               Kaskazini Centre is an Online and physical Training model that
//               supports youth (morans and young women) in Rural areas, one of the
//               key groups who provide labor(herding), and homestead security, but
//               do not own any economic skill, and have low literacy level.
//               Kaskazini Centre seeks to equip them with alternative
//               opportunities to diversify their livelihoods, mitigate on
//               continued poverty and conflict cycles especially through filming
//               and photography skills.
//             </p>

//             <div className="max-w-3xl mx-auto text-white">
//               <h1 className=" mb-10 mt-10 text-4xl font-bold text-red-500">
//                 Problems identified
//               </h1>
//               <div className="mb-8">
//                 <h3 className="text-2xl font-bold mb-2 text-red-500">
//                   1. Lack of Access to Formal Education
//                 </h3>
//                 <p className="text-white text-left">
//                   Majority of the people living in Northern Kenya lack access to
//                   formal education because of the need to take care of livestock
//                   and cater for their families.
//                 </p>
//               </div>

//               <div className="mb-8">
//                 <h3 className="text-2xl font-bold mb-2 text-red-500">
//                   2. Impact of Increased Costs of Living
//                 </h3>
//                 <p className="text-white text-left">
//                   With the increased costs of living taking place all over the
//                   world the communities back in Northern Kenya are largely
//                   affected due to lack of alternative livelihoods. Majority
//                   being pastoralists are casualties of climate change hence
//                   losing their source of income.
//                 </p>
//               </div>

//               <div className="mb-8">
//                 <h3 className="text-2xl font-bold mb-2 text-red-500">
//                   3. Limited Access to Skills Training and Job Opportunities
//                 </h3>
//                 <p className="text-white text-left">
//                   Northern Kenya and most parts of rural areas in Kenya lack
//                   access to skills center to train and link them with job
//                   opportunities, especially the informal sector.
//                 </p>
//               </div>
//             </div>
//           </div>
//           <Objectives />
//         </div>
//       </div>
//       <div
//         className=" card bg-base-100 shadow-xl mt-20"
//         style={{ marginTop: 0 }}
//       >
//         <figure style={{ margin: 0 }}>
//           <img
//             src={kaskazini2}
//             alt="kaskazini centre"
//             style={{ width: "80%", margin: "auto" }}
//           />
//         </figure>
//         <div className="bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
//           <div className="bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
//             <div className="max-w-7xl mx-auto">
//               <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
//                 Empowering Youth Through Filming and Photography
//               </h2>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                 <div className="bg-red-700 rounded-lg p-6 shadow-md">
//                   <h3 className="text-xl font-bold mb-4 text-white">
//                     Skills Training
//                   </h3>
//                   <p className="text-white mb-4">
//                     We train youths on filming and photography as a way of
//                     creating their own jobs and sharing community stories to
//                     promote social awareness.
//                   </p>
//                 </div>
//                 <div className="bg-red-700 rounded-lg p-6 shadow-md">
//                   <h3 className="text-xl font-bold mb-4 text-white">
//                     Consultancy
//                   </h3>
//                   <p className="text-white mb-4">
//                     We offer consulting services to organisations and agencies
//                     working with youths in rural areas to equip them with
//                     informal knowledge and skills.
//                   </p>
//                 </div>
//               </div>
//               <div className="flex justify-center mt-8">
//                 <div className="bg-red-700 rounded-lg p-6 shadow-md w-full sm:w-1/2">
//                   <h3 className="text-xl font-bold mb-4 text-white">
//                     Marketing
//                   </h3>
//                   <p className="text-white mb-4">
//                     We provide distribution and promotional services to the
//                     community project films and photography works such as access
//                     to film grants, festivals, and sales.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* <button
//       className="btn donate-btn bg-red-500 text-white text-lg font-bold py-3 px-6 rounded-lg"
//       style={{
//         animation: "ring 1.5s infinite",
//         // Other styles here
//       }}
//     >
//       Donate Now
//     </button> */}

//         </div>
//       </div>
//     </>
//   );
// }

// export default Campaign;


import React from "react";
import kaskazini from "../Assets/Images/kaskaz.jpg";
import kaskazini2 from "../Assets/Images/kaskazini2.jpeg";
import st1 from "../Assets/Images/st1.jpg";
import st2 from "../Assets/Images/st2.jpg";
import Objectives from "../components/Objectives";
import Navbar from "../components/Navbar";

function Campaign() {
  return (
    <>
      <Navbar />

      {/* Hero */}
      <section className="bg-red-700 text-white py-24 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-4">Kaskazini Centre</h1>
          <p className="text-lg md:text-xl mb-6">
            Empowering youth in Northern Kenya through storytelling,
            photography, and skills training.
          </p>
          <a
            href="#projects"
            className="bg-white text-red-700 px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition"
          >
            View Our Projects
          </a>
        </div>
      </section>

      {/* About */}
      <section className="bg-white py-20 px-4">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <img
            src={kaskazini}
            alt="Kaskazini Centre"
            className="w-full rounded-xl shadow-md"
          />
          <div>
            <h2 className="text-3xl font-bold text-red-700 mb-4">Our Mission</h2>
            <p className="text-gray-700 leading-relaxed">
              Kaskazini Centre is an Online and physical Training model that supports youth (morans and young women) in Rural areas, one of the key groups who provide labor(herding), and homestead security, but do not own any economic skill, and have low literacy level. Kaskazini Centre seeks to equip them with alternative opportunities to diversify their livelihoods, mitigate on continued poverty and conflict cycles especially through filming and photography skills.
            </p>
          </div>
        </div>
      </section>

      {/* Problems Identified */}
      <section className="bg-gray-100 py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-red-700 mb-12">
            Problems We Address
          </h2>
          <div className="grid md:grid-cols-3 gap-10">
            {[
              {
                title: "Lack of Access to Formal Education",
                desc: "Many youth lack access to formal education due to pastoral responsibilities.",
              },
              {
                title: "Economic Struggles",
                desc: "With the increased costs of living taking place all over the world the communities back in Northern Kenya are largely affected due to lack of alternative livelihoods. Majority being pastoralists are casualties of climate change hence losing their source of income.",
              },
              {
                title: "Limited Access to Skills Training and Job Opportunities",
                desc: "Northern Kenya and most parts of rural areas in Kenya lack access to skills center to train and link them with job opportunities, especially the informal sector.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white rounded-xl p-6 shadow hover:shadow-lg transition"
              >
                <h3 className="text-xl font-semibold text-red-700 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Objectives */}
      <section className="bg-white py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <Objectives />
        </div>
      </section>

      {/* Programs */}
      <section className="bg-red-700 py-20 px-4 text-white">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-12">Our Core Programs</h2>
          <div className="grid md:grid-cols-3 gap-10">
            {[
              {
                title: "Skills Training",
                desc: "We train youths on filming and photography as a way of creating their own jobs and sharing community stories to promote social awareness.",
              },
              {
                title: "Consultancy",
                desc: "We offer consulting services to organisations and agencies working with youths in rural areas to equip them with informal knowledge and skills.",
              },
              {
                title: "Marketing & Distribution",
                desc: "We provide distribution and promotional services to the community project films and photography works such as access to film grants, festivals, and sales.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white text-red-700 p-6 rounded-xl shadow hover:shadow-xl transition"
              >
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects by the Hub */}
      <section id="projects" className="bg-gray-100 py-20 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-red-700 mb-12">
            Projects by the Hub
          </h2>
          <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
            {[
              {
                title: "Kaskazini Mobile Film Project Masterclass",
                image: st1,
                description:
                  "Bringing filmmaking tools to remote communities through mobile kits and local trainers.",
              },
              {
                title: "Digital Media Training in Partnership with Ajira Digital",
                image: st2,
                description:
                  "Kaskazini Center Partners with Ajira Digital to Expand Film and Digital Media Training",
              },
              // {
              //   title: "Community Screenings",
              //   image: kaskazini,
              //   description:
              //     "Public screenings of youth-made films to spark dialogue on social issues.",
              // },
            ].map((project, index) => (
              <div
                key={index}
                className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="h-48 w-full object-cover"
                />
                <div className="p-5 text-left">
                  <h3 className="text-xl font-semibold text-red-700 mb-2">
                    {project.title}
                  </h3>
                  <p className="text-sm text-gray-700">
                    {project.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-white py-16 text-center">
        <h2 className="text-3xl font-bold text-red-700 mb-6">
          Want to Support Our Work?
        </h2>
        <p className="text-gray-600 mb-6">
          Help us reach more youth with training, equipment, and opportunity.
        </p>
        <button className="bg-red-700 text-white px-6 py-3 rounded-full hover:bg-red-800 transition">
          Donate or Partner With Us
        </button>
      </section>
    </>
  );
}

export default Campaign;

